import React from 'react';
import { connect } from 'react-redux';
import { Tr, Td, Button, Text } from '@chakra-ui/react';
import { MdShoppingCart } from 'react-icons/md';
import { ReduxState } from '../../store/state';
import { PageOrderConfirmation } from '../../store/page/types';

const allowedStatusTypes = [
  'created',
  'awaiting payment',
  'accepted',
  'started',
  'picked up',
  'on the way',
  'delivered',
  'cancelled',
  'failed'
];

interface OrderRowProps {
    order: PageOrderConfirmation;
    hideAmount?: boolean
}

class OrderRow extends React.Component<OrderRowProps> {
  getStatusColor = (status: string) => {
    if (allowedStatusTypes.includes(status)) {
      switch (status) {
        case 'cancelled':
        case 'failed':
          return 'red';
        case 'awaiting payment':
            return 'yellow'
        case 'delivered':
          return 'green';
        default:
          return 'gray';
      }
    }
    return 'gray'; 
  }

  formatCurrency = (currency: string, amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(amount);
  }
  
  render() {
    const { order } = this.props;

    return (
      <Tr key={order.orderNumber} style={{ background: 'white' }} boxShadow="0 2px 8px rgba(0, 0, 0, 0.2)">
        <Td>
          <Button size={'xs'} leftIcon={<MdShoppingCart />} borderRadius={'full'}>
            <Text>{order.orderNumber}</Text>
          </Button>
        </Td>
        {this.props.hideAmount ? null : (
          <Td>
            <Text fontSize='sm' color='gray.600' style={{ textAlign: 'right' }}>{order.currency ? this.formatCurrency(order.currency, order.orderRevenue) : null}</Text>
          </Td>
        )}
        <Td>
          <Button
            colorScheme={this.getStatusColor(order.status)}
            size='xs'
            ml={1}
          >
            {order.status}
          </Button>
        </Td>
      </Tr>
    );
  }
}

const mapStateToProps = (state: ReduxState) => {
  return { };
};

export default connect(mapStateToProps, { 
})(OrderRow);
